import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../environment/environment';
import { AuthService } from './auth.service';  // Adjust the path to your AuthService
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Only add auth headers to internal API requests
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const authHeaders = authService.authorization();

  let authReq = req.clone({
    setHeaders: authHeaders
  });

  if (authReq.body !== null) {
    let encrypted = encrypt(authReq.body);
    authReq = req.clone({
      body: { data: encrypted },
      setHeaders: authHeaders,
    });
  }

  return next(authReq).pipe(
    map((event) => {
      if (event instanceof HttpResponse && event.body) {
        let encryptedBody: string | undefined = (event.body as { data?: string }).data;
        if (encryptedBody) {
          const decryptedBody = decrypt(encryptedBody);
          return event.clone({ body: decryptedBody });
        } else {
          console.warn('No encrypted data found in response body.');
          return event;
        }
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.error('Unauthorized request. Redirecting to login.');
        authService.clearToken();
        return throwError(() => error);
      }
      // Decrypt error response body if it's encrypted
      if (error.error && typeof error.error === 'object' && error.error.data) {
        try {
          const decryptedError = decryptRecursively(error.error);
          console.error('Fully decrypted error response:', decryptedError);

          const decryptedErrorResponse = new HttpErrorResponse({
            error: decryptedError,
            headers: error.headers,
            status: error.status,
            statusText: error.statusText ?? undefined,
            url: error.url ?? undefined
          });
          return throwError(() => decryptedErrorResponse);
        } catch (decryptError) {
          console.error('Failed to decrypt error response:', decryptError);
          console.log('Original error for debugging:', error.error);
          return throwError(() => error);
        }
      }

      return throwError(() => error);
    })
  );
};


export function encrypt(data: any): string {
  const key = CryptoJS.enc.Utf8.parse('8rz!q3jme_ikk&yf');
  const iv = CryptoJS.enc.Utf8.parse('8rz!q3jme_ikk&yf');

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  }).toString();

  return encrypted;
}



export function decrypt(data: any): any {
  if (typeof data !== 'string') {
    console.error('Decryption failed: Response body is not an encrypted string.');
    return data;
  }
  const key = CryptoJS.enc.Utf8.parse('8rz!q3jme_ikk&yf');
  const iv = CryptoJS.enc.Utf8.parse('8rz!q3jme_ikk&yf');
  try {
    const decipher = CryptoJS.AES.decrypt(data, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });

    const decryptedString = decipher.toString(CryptoJS.enc.Utf8);

    if (decryptedString) {
      return JSON.parse(decryptedString);
    } else {
      return data;
    }
  } catch (error) {
    console.error('Error decrypting response body', error);
    return data;
  }
}

// Helper function to recursively decrypt data
export function decryptRecursively(data: any, maxDepth: number = 3): any {
  if (typeof data === 'string') {
    try {
      const decrypted = decrypt(data);

      return decrypted;
    } catch (error) {
      console.error('Failed to decrypt string:', error);
      return data;
    }
  }

  if (typeof data === 'object' && data !== null) {
    if (data.data && typeof data.data === 'string') {
      try {
        const decryptedData = decrypt(data.data);
        return decryptRecursively(decryptedData, maxDepth - 1);
      } catch (error) {
        console.error('Failed to decrypt data field:', error);
        return data;
      }
    }

    // Recursively decrypt object properties
    const result: any = {};
    for (const [key, value] of Object.entries(data)) {
      result[key] = decryptRecursively(value, maxDepth - 1);
    }
    return result;
  }

  return data;
}



